export const changeBookNums = (pageNum: number) => {
  if (pageNum < 1 || pageNum > 48) return pageNum;
  return pageNum * 2 - 1;
};

export const blurActiveElement = () => {
  if (typeof document === "undefined") return;

  const activeElement = document.activeElement;

  if (activeElement instanceof HTMLElement) {
    activeElement.blur();
  }
};
